import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  static targets = ["selectBox", "otherInput"];
  static values = {
    options: Array,
    selected: String,
    enableOtherOption: Boolean
  }

  connect() {
    this.loadOptions();
    this.handleOtherOption();
    this.handleFormSubmit();

  }

  loadOptions() {
    const selectElement = this.hasSelectBoxTarget ? this.selectBoxTarget : this.element;

    this.optionsValue.forEach(option => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.textContent = option.label;
      if (option.value === this.selectedValue) {
        optionElement.selected = true;
      }
      selectElement.appendChild(optionElement);
    });

    if (this.enableOtherOptionValue) {
      const otherOptionElement = document.createElement('option');
      otherOptionElement.value = 'other';
      otherOptionElement.textContent = '기타';
      selectElement.appendChild(otherOptionElement);
    }
  }

  handleOtherOption() {
    const selectElement = this.hasSelectBoxTarget ? this.selectBoxTarget : this.element;

    if (this.enableOtherOptionValue) {
      selectElement.addEventListener('change', (event) => {
        if (event.target.value === 'other') {
          this.otherInputTarget.style.display = 'block';
          selectElement.name = "";
        } else {
          this.otherInputTarget.style.display = 'none';
          selectElement.name = "entryroute";
        }
      });
    }
  }
  handleFormSubmit() {
    const formElement = this.element.closest('form');
    if (formElement) {
      formElement.addEventListener('submit', () => {
        const selectElement = this.hasSelectBoxTarget ? this.selectBoxTarget : this.element;
        if (selectElement.value === 'other' && this.otherInputTarget.value) {
          this.otherInputTarget.value = "기타 - " + this.otherInputTarget.value;
        }
      });
    }
  }
}
